import React, { createRef, FC } from 'react';
import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MfDialog from '../UI/Dialog/MfDialog';
import FeedbackForm from './FeedbackForm';
import MfAlert from '../UI/Alert/MfAlert';

interface Props {
  open: boolean;
  onClose: () => void;
}

const FeedbackDialog: FC<Props> = ({ open, onClose }) => {
  const theme = useTheme();
  const fs = useMediaQuery(theme.breakpoints.down('md'));
  const formRef = createRef<HTMLFormElement>();

  const submit = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event('submit', { cancelable: true, bubbles: true })
      );
    }
  };

  return (
    <MfDialog
      onClose={onClose}
      open={open}
      title="Обратная связь"
      maxWidth="md"
      onOk={submit}
      okLabel="Сохранить"
      fullScreen={fs}
    >
      <MfAlert
        severity="info"
        sx={{
          mb: 3,
          fontWeight: 600,
        }}
      >
        <div>
          Нужна помощь? Изучите{' '}
          <Link target="_blank" href="https://www.moneyfriends.ru/faq.html">
            ответы на частозадаваемые вопросы
          </Link>
        </div>
      </MfAlert>
      <Box sx={{ fontWeight: 600, mb: 3 }}>Или свяжитесь с нами</Box>
      <FeedbackForm onSubmitted={onClose} formRef={formRef} />
    </MfDialog>
  );
};

export default FeedbackDialog;
